import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getFromBrandConfig } from 'brand-config';
import {
  selectMissingPii,
  selectIsUserAgent,
} from 'services/session/sessionSelectors';
import { selectUserId } from 'services/user/userSelectors';

const selectMiscState = (state: RootState) => state.misc;

export const selectIsDbooProfileUpdated = createSelector(
  [selectMiscState],
  (miscState) => miscState.isDbooProfileUpdated,
);

export const selectIsWatchlistProfileUpdated = createSelector(
  [selectMiscState],
  (miscState) => miscState.isWatchlistProfileUpdated,
);

export const selectIsDataCollectionModalClosed = createSelector(
  [selectMiscState],
  (miscState) => miscState.isDataCollectionModalClosed,
);

export const selectIsDataCollectionBannerClosed = createSelector(
  [selectMiscState],
  (miscState) => miscState.isDataCollectionBannerClosed,
);

export const selectIsEligibleForDataCollection = createSelector(
  [selectMissingPii, selectIsUserAgent, selectUserId],
  (missingPii, isAgent, userId) =>
    !!getFromBrandConfig('missingPII') &&
    !!userId &&
    !isAgent &&
    !!missingPii?.length,
);
